module.exports = __webpack_public_path__ + "static/img/ice_card@2x.b216bdb1.png";